import { List } from 'immutable';
import AgreementVersionSpecialPrice from '../../../interfaces/output/agreementVersionSpecialPriceOut';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';
import ValidationUtils from '../../../utils/validationUtils';
import LoadedFlag from '../../../constants/AgreementLoadedFlagEnum';

const messages = {
    requiredFields: LanguageUtils.createMessage('Validation error general'),
    invalidDates: LanguageUtils.createMessage('Invalid date range'),
    invalidDateFormat: LanguageUtils.createMessage('Invalid date format'),
    outOfRange: LanguageUtils.createMessage('Value out of range')
};

export default class AgreementVersionSpecialPriceStep1Validation extends ValidationUtils {

    static validateRequiredDate(inputDate: Date | undefined): boolean {
        return !!inputDate;
    }

    static validateInputDateStart(agreementVersionSpecialPrice: AgreementVersionSpecialPrice): boolean {
        const dateStart = agreementVersionSpecialPrice.validFromDate;
        const dateTo = agreementVersionSpecialPrice.validToDate;

        return this.validateDateTimeRangeStart(dateStart, dateTo);
    }

    static validateInputDateEnd(agreementVersionSpecialPrice: AgreementVersionSpecialPrice): boolean {
        const dateStart = agreementVersionSpecialPrice.validFromDate;
        const dateTo = agreementVersionSpecialPrice.validToDate;

        return this.validateDateTimeRangeTo(dateStart, dateTo);
    }

    static validateGrossWeightInInterval(agreementVersionSpecialPrice: AgreementVersionSpecialPrice): boolean {

        return (agreementVersionSpecialPrice?.loadedFlag?.code === LoadedFlag.EMPTY) ?
            this.numberIsInInterval(agreementVersionSpecialPrice?.grossWeightKgTo, 0, 11000) : true;
    }

    static validateAgreementVersionSpecialPriceForm(agreementVersionSpecialPrice: AgreementVersionSpecialPrice): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;

        const { validFromDate,
            validToDate,
            grossWeightKgFrom,
            grossWeightKgTo,
            price,
            terminalFrom,
            terminalTo,
            unitType
        } = agreementVersionSpecialPrice;

        const requiredFields =
            this.validateRequiredDate(validFromDate) &&
            this.validateRequiredDate(validToDate) &&
            this.validateInputNumber(grossWeightKgFrom) &&
            this.validateInputNumber(grossWeightKgTo) &&
            this.validateInputNumber(price) &&
            this.validateInputNumber(terminalFrom?.id) &&
            this.validateInputNumber(terminalTo?.id) &&
            this.validateInputNumber(unitType?.unitGroupId) &&
            this.validateInputNumber(unitType?.unitSubGroupId) &&
            this.validateInputNumber(unitType?.id);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        const endDate = agreementVersionSpecialPrice.validToDate;
        const validDates = endDate ? this.validateInputDateStart(agreementVersionSpecialPrice) &&
            this.validateInputDateEnd(agreementVersionSpecialPrice) : true;

        if(!validDates) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.invalidDates);
        }

        const formatedDate = this.validateDateFormat(validFromDate) &&
            this.validateDateFormat(validToDate);

        const grossInInterval = this.validateGrossWeightInInterval(agreementVersionSpecialPrice);

        if(!formatedDate) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.invalidDateFormat);
        }

        if(!grossInInterval) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.outOfRange);
        }

        return validationModel;
    }
}
